<template>
    <div class="bg-wrap">
        <div>
            <Header  @changeOn="changeOn"></Header>
        </div>
        <div class="content">
<!--            <div class="brief">-->
<!--                <div class="brief-item">-->
<!--                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/schedule/icon-tv.png">-->
<!--                    <span>时间：2022年6月19日 08:30-12:30</span>-->
<!--                </div>-->
<!--                <div class="brief-item">-->
<!--                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/schedule/icon-location.png">-->
<!--                    <span>地点：8个城市搭建绿幕做虚拟直播（上海、北京、广州、杭州、西安、济南、乌鲁木齐、苏州)</span>-->
<!--                </div>-->
<!--                <div class="brief-item">-->
<!--                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/schedule/icon-tv.png">-->
<!--                    <span>线上接入ZOOM会议号：920 9701 6023</span>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="detail">-->
<!--                <div class="time">-->
<!--                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/schedule/time.png">-->
<!--                </div>-->
<!--                <div class="text">-->
<!--                    <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/schedule/text.png">-->
<!--                </div>-->
<!--            </div>-->

            <div class="title">
                <span>会议日程</span>
            </div>
            
            <div class="schedule">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/schedule/schedule-10.png">
            </div>

<!--            <div class="detail">-->
<!--                <div class="d-item enlight">-->
<!--                    <span>08:30-08:35</span>-->
<!--                    <span>开场视频</span>-->
<!--                    <span>全 体</span>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div v-for="(value,index) in datas" v-bind:key="index">-->
<!--                <div class="item item-head" >-->
<!--                    <span>{{value.title}}</span>-->
<!--                </div>-->
<!--                <div  class="item-show" :class="index2%2==0?'item-single':'item-double'" v-for="(v2,index2) in value.content " v-bind:key="index2" >-->
<!--                    <span>{{v2.time}}</span>-->
<!--                    <span>{{v2.title}}</span>-->
<!--                    <span>{{v2.speaker}}</span>-->
<!--                </div>-->
<!--            </div>-->

        </div>
    </div>
</template>

<script>
    import Header from "./Head"

    export default {
        data() {
            return {
                section: "会议日程",
                datas: [
                    {
                        title: "篇章一：序",
                        content: [
                            {time: "08:30", title: "致开篇辞", speaker: "李建平(待定)"},
                            {time: "08:30-08:40", title: "致开篇辞", speaker: "李建平(待定)"},
                            {time: "08:30-08:40", title: "致开篇辞", speaker: "李建平(待定)"},
                            {time: "08:30-08:40", title: "致开篇辞", speaker: "李建平(待定)"}
                            ]
                    },
                    {
                        title: "篇章二：序",
                        content: [
                            {time: "08:30-08:40", title: "致开篇辞", speaker: "李建平(待定)"},
                            {time: "08:30-08:40", title: "致开篇辞", speaker: "李建平(待定)"},
                            {time: "08:30-08:40", title: "致开篇辞", speaker: "李建平(待定)"},
                            {time: "08:30-08:40", title: "致开篇辞", speaker: "李建平(待定)"},
                        ]
                    },
                    {
                        title: "篇章三：序",
                        content: [
                            {time: "08:30-08:40", title: "致开篇辞", speaker: "李建平(待定)"},
                            {time: "08:30-08:40", title: "致开篇辞", speaker: "李建平(待定)"},
                            {time: "08:30-08:40", title: "致开篇辞", speaker: "李建平(待定)"},
                            {time: "08:30-08:40", title: "致开篇辞", speaker: "李建平(待定)"},
                        ]
                    },
                ]
            }
        },
        components: {
            Header
        },
        methods:{
            changeOn(val){
                console.log("onOrOff="+val)
                if (val){
                    this.$parent.$refs.audio.pause();
                }else{
                    this.$parent.$refs.audio.play();
                }
                //
            },
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/hz/bg-2.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        overflow: scroll;
    }

    .content {
        color: #FFF;
        font-size: 10px;
        margin: 0 10px 40px 10px;
        .section {
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 10px;
        }
    }

    .title{
        margin-bottom: 10px;
        font-size: 13px;
        font-weight: bold;
    }

    .item{
        margin-bottom: 10px;
    }
    .item-show{
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        span:first-child{
            width: 28%;
            text-align: center;
        }
        span:nth-child(2){
            flex-grow: 1;
        }
        span:last-child{
            margin-right: 5px;
        }
    }

    .item-head{
        background: #66c2e6;
        border-radius: 5px;
        text-align: left;
        padding: 2px 12px;
    }

    .item-single{
        text-align: left;
    }

    .item-double{
        background:rgba(255,255,255,0.2);
        border-radius: 5px;
        padding: 2px 2px;
        text-align: left;

    }


    .brief{
        width: 100%;
        .brief-item{
            display: flex;
            align-items: center;
            margin-bottom: 5px;
            width: 100%;
            img{
                width: 20px;
            }
            span{
                margin-left: 10px;
                text-align: left;
            }
        }
    }

    .detail{
        display: flex;
        flex-direction: row;
        .time{
            width: 50%;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            img{
                width: 80px;
            }
        }
        .text{
            width: 50%;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            margin-top: -20px;
            img{
                width: 200px;
            }
        }
    }

    .schedule{
        width: 100%;
        img{
            width: 100%;
        }
    }



    ::-webkit-scrollbar{
        width: 0;
    }


</style>